import { Linkedin, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="py-28 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <Eyebrow>Founder &amp; Managing Director</Eyebrow>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl text-[#1b2a4e] tracking-tight leading-[1.1]">
            Counsel called to two Bars. <span className="italic text-[#a8824f]">A decade in the City.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-8 space-y-5 text-[#45506b] text-base leading-relaxed max-w-2xl">
            <p>
              Janice Acquaah is a dedicated legal and financial services regulatory compliance
              professional, dual-qualified at the Ghana Bar (1995) and the England &amp; Wales Bar
              (2008), with over ten years' experience in the City of London's financial services
              sector — spanning compliance frameworks, financial crime prevention, risk management
              and governance.
            </p>
            <p>
              Her work covers regulatory change, policy development, control design, monitoring and
              advisory support across a wide range of financial institutions: engaging senior
              stakeholders, managing regulatory interactions and driving improvements in compliance
              maturity and operational resilience.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.18}>
          <div className="mt-8 flex items-start gap-4 max-w-2xl border-l-2 border-[#a8824f] pl-6">
            <Quote size={20} className="text-[#a8824f] shrink-0 mt-1" />
            <p className="font-display italic text-lg sm:text-xl text-[#1b2a4e] leading-relaxed">
              Compliance should be embedded into culture, operations and customer outcomes —
              building a safer, more transparent financial system where firms operate responsibly.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.24}>
          <div className="mt-9 flex flex-wrap items-center gap-3">
            {["Ghana Bar · 1995", "England & Wales Bar · 2008", "Financial Crime Prevention", "Governance & Risk"].map((chip) => (
              <span
                key={chip}
                className="font-mono-alt text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-[#45506b] px-4 py-2 rounded-full border border-[#e6e1d5] bg-[#faf9f6]"
              >
                {chip}
              </span>
            ))}
            <a
              data-testid="founder-linkedin-link"
              href="https://www.linkedin.com/in/janice-acquaah-5a3b0a8/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-xs font-semibold text-[#1b2a4e] hover:text-[#a8824f] px-4 py-2 rounded-full border border-[#e6e1d5] hover:border-[#a8824f]/60 transition-colors focus:outline-none focus:ring-2 focus:ring-[#a8824f]"
            >
              <Linkedin size={14} className="text-[#a8824f]" />
              Connect on LinkedIn
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
